import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Header from "../../../common/header/Header";
import Breadcrumb from "../../../common/header/Breadcrumb";
import ISGSettings from "../../../components/InspectorServiceGroup/ISGSettings";

const InspectorServiceGroup = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
      <Box className="page-background">
        <Header />
        <Breadcrumb />
        <ISGSettings />
      </Box>
    </>
  );
};

export default InspectorServiceGroup;
